import { CurrencyEnum } from "@/lib/enum/currency.enum";

export const currencySymbolMap = new Map<CurrencyEnum, string>([
  [CurrencyEnum.AED, "د.إ."],
  [CurrencyEnum.AFN, "؋"],
  [CurrencyEnum.ALL, "L"],
  [CurrencyEnum.AMD, "֏"],
  [CurrencyEnum.ANG, "ƒ"],
  [CurrencyEnum.AOA, "Kz"],
  [CurrencyEnum.ARS, "AR$"],
  [CurrencyEnum.AUD, "AU$"],
  [CurrencyEnum.AWG, "ƒ"],
  [CurrencyEnum.AZN, "₼"],
  [CurrencyEnum.BAM, "KM"],
  [CurrencyEnum.BBD, "BBD$"],
  [CurrencyEnum.BDT, "৳"],
  [CurrencyEnum.BGN, "лв."],
  [CurrencyEnum.BHD, "BD"],
  [CurrencyEnum.BIF, "FBu"],
  [CurrencyEnum.BMD, "$"],
  [CurrencyEnum.BND, "B$"],
  [CurrencyEnum.BOB, "Bs."],
  [CurrencyEnum.BRL, "R$"],
  [CurrencyEnum.BSD, "$"],
  [CurrencyEnum.BTN, "Nu."],
  [CurrencyEnum.BWP, "P"],
  [CurrencyEnum.BYN, "Br"],
  [CurrencyEnum.CAD, "CA$"],
  [CurrencyEnum.CDF, "FC"],
  [CurrencyEnum.CHF, "Fr."],
  [CurrencyEnum.CLP, "CL$"],
  [CurrencyEnum.CNY, "CN¥"],
  [CurrencyEnum.COP, "CO$"],
  [CurrencyEnum.CRC, "₡"],
  [CurrencyEnum.CUC, "CUC$"],
  [CurrencyEnum.CUP, "$MN"],
  [CurrencyEnum.CVE, "CV$"],
  [CurrencyEnum.CZK, "Kč"],
  [CurrencyEnum.DJF, "Fdj"],
  [CurrencyEnum.DKK, "kr."],
  [CurrencyEnum.DOP, "RD$"],
  [CurrencyEnum.DZD, "DA"],
  [CurrencyEnum.EGP, "E£"],
  [CurrencyEnum.ERN, "Nkf"],
  [CurrencyEnum.ETB, "Br"],
  [CurrencyEnum.EUR, "€"],
  [CurrencyEnum.FJD, "FJ$"],
  [CurrencyEnum.FKP, "FK£"],
  [CurrencyEnum.GBP, "£"],
  [CurrencyEnum.GEL, "₾"],
  [CurrencyEnum.GHS, "GH₵"],
  [CurrencyEnum.GIP, "£"],
  [CurrencyEnum.GMD, "D"],
  [CurrencyEnum.GNF, "FG"],
  [CurrencyEnum.GTQ, "Q"],
  [CurrencyEnum.GYD, "G$"],
  [CurrencyEnum.HKD, "HK$"],
  [CurrencyEnum.HNL, "L"],
  [CurrencyEnum.HRK, "kn"],
  [CurrencyEnum.HTG, "G"],
  [CurrencyEnum.HUF, "Ft"],
  [CurrencyEnum.IDR, "Rp"],
  [CurrencyEnum.ILS, "₪"],
  [CurrencyEnum.INR, "Rs."],
  [CurrencyEnum.IQD, "د.ع."],
  [CurrencyEnum.IRR, "﷼"],
  [CurrencyEnum.ISK, "kr"],
  [CurrencyEnum.JMD, "J$"],
  [CurrencyEnum.JOD, "JD"],
  [CurrencyEnum.JPY, "¥"],
  [CurrencyEnum.KES, "KSh"],
  [CurrencyEnum.KGS, "с"],
  [CurrencyEnum.KHR, "៛"],
  [CurrencyEnum.KMF, "CF"],
  [CurrencyEnum.KPW, "₩"],
  [CurrencyEnum.KRW, "₩"],
  [CurrencyEnum.KWD, "KD"],
  [CurrencyEnum.KYD, "CI$"],
  [CurrencyEnum.KZT, "₸"],
  [CurrencyEnum.LAK, "₭N"],
  [CurrencyEnum.LBP, "LL."],
  [CurrencyEnum.LKR, "Rs."],
  [CurrencyEnum.LRD, "L$"],
  [CurrencyEnum.LSL, "L"],
  [CurrencyEnum.LYD, "LD"],
  [CurrencyEnum.MAD, "DH"],
  [CurrencyEnum.MDL, "L"],
  [CurrencyEnum.MGA, "Ar"],
  [CurrencyEnum.MKD, "den"],
  [CurrencyEnum.MMK, "Ks"],
  [CurrencyEnum.MNT, "₮"],
  [CurrencyEnum.MOP, "MOP$"],
  [CurrencyEnum.MRU, "UM"],
  [CurrencyEnum.MUR, "Rs."],
  [CurrencyEnum.MVR, "MRf"],
  [CurrencyEnum.MWK, "MK"],
  [CurrencyEnum.MXN, "MX$"],
  [CurrencyEnum.MYR, "RM"],
  [CurrencyEnum.MZN, "MTn"],
  [CurrencyEnum.NAD, "N$"],
  [CurrencyEnum.NGN, "₦"],
  [CurrencyEnum.NIO, "C$"],
  [CurrencyEnum.NOK, "kr"],
  [CurrencyEnum.NPR, "Rs."],
  [CurrencyEnum.NZD, "NZ$"],
  [CurrencyEnum.OMR, "OR"],
  [CurrencyEnum.PAB, "B/."],
  [CurrencyEnum.PEN, "S/."],
  [CurrencyEnum.PGK, "K"],
  [CurrencyEnum.PHP, "₱"],
  [CurrencyEnum.PKR, "Rs."],
  [CurrencyEnum.PLN, "zł"],
  [CurrencyEnum.PYG, "₲"],
  [CurrencyEnum.QAR, "QR"],
  [CurrencyEnum.RON, "L"],
  [CurrencyEnum.RSD, "din"],
  [CurrencyEnum.RUB, "₽"],
  [CurrencyEnum.RWF, "FRw"],
  [CurrencyEnum.SAR, "SR"],
  [CurrencyEnum.SBD, "SI$"],
  [CurrencyEnum.SCR, "Rs."],
  [CurrencyEnum.SDG, "£SD"],
  [CurrencyEnum.SEK, "kr"],
  [CurrencyEnum.SGD, "S$"],
  [CurrencyEnum.SHP, "£"],
  [CurrencyEnum.SLL, "Le"],
  [CurrencyEnum.SOS, "Sh.So."],
  [CurrencyEnum.SRD, "Sr$"],
  [CurrencyEnum.SSP, "SS£"],
  [CurrencyEnum.STN, "Db"],
  [CurrencyEnum.SVC, "₡"],
  [CurrencyEnum.SYP, "LS"],
  [CurrencyEnum.SZL, "L"],
  [CurrencyEnum.THB, "฿"],
  [CurrencyEnum.TJS, "SM"],
  [CurrencyEnum.TMT, "m."],
  [CurrencyEnum.TND, "DT"],
  [CurrencyEnum.TOP, "T$"],
  [CurrencyEnum.TRY, "TL"],
  [CurrencyEnum.TTD, "TT$"],
  [CurrencyEnum.TWD, "NT$"],
  [CurrencyEnum.TZS, "TSh"],
  [CurrencyEnum.UAH, "₴"],
  [CurrencyEnum.UGX, "USh"],
  [CurrencyEnum.USD, "$"],
  [CurrencyEnum.UYU, "$U"],
  [CurrencyEnum.UZS, "сум"],
  [CurrencyEnum.VED, "Bs."],
  [CurrencyEnum.VES, "Bs.F"],
  [CurrencyEnum.VND, "₫"],
  [CurrencyEnum.VUV, "VT"],
  [CurrencyEnum.WST, "T"],
  [CurrencyEnum.XAF, "Fr"],
  [CurrencyEnum.XCD, "$"],
  [CurrencyEnum.XOF, "₣"],
  [CurrencyEnum.XPF, "₣"],
  [CurrencyEnum.YER, "YR"],
  [CurrencyEnum.ZAR, "R"],
  [CurrencyEnum.ZMW, "ZK"],
  [CurrencyEnum.ZWL, "Z$"]
]);
